import { render, staticRenderFns } from "./FantasyPointsSystem.vue?vue&type=template&id=a2f024fc&scoped=true&"
import script from "./FantasyPointsSystem.vue?vue&type=script&lang=js&"
export * from "./FantasyPointsSystem.vue?vue&type=script&lang=js&"
import style0 from "./FantasyPointsSystem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FantasyPointsSystem.vue?vue&type=style&index=1&id=a2f024fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f024fc",
  null
  
)

export default component.exports